import type { IconSvgObject } from './types';

const SevenCircleIcon: IconSvgObject = [
  ["path", { d: "M9 7H14.584C14.8138 7 15 7.18625 15 7.41599C15 7.47144 14.9889 7.52632 14.9674 7.57742L11 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default SevenCircleIcon;
